import raf            from 'raf';
import helperA11y     from 'shared/mixins/helper-a11y';

/**
 * @module
 *
 */

const selector = '[data-js-accordion]';
const accordionContent = function(el, app) {

    const a11yHelper                = helperA11y(app);

    let   acceptingClicks = false;
    const $el = $(el);

    const init = function() {
        // don't init if inside a popover - it will be initialised when the popover is initialised
        if ($el.closest('[data-js-popup]').length) {
            return;
        }
        setupAccordion();
        registerEvents();
        acceptingClicks = true;
        // notify other methods that the accordion is ready
        raf(function tick1() {
            raf(function tick2() {
                app.trigger('accordionReady',[$el]);
                $el.addClass('Ge-Accordion--animate');
            });
        });
    };

    /*
     * by default all accordions are accessible and open, with no toggle switches.
     * on initialisation, they closed/left open (no animation).
     * after set-up, any further changes are animated.
     */
    const setupAccordion = function() {
        $el.addClass('Ge-Accordion--ready');
        $el.find('.Ge-Accordion-item:not(.Ge-Accordion-item--open)').addClass('Ge-Accordion-item--closed');
        $el.find('.Ge-Accordion-item:not(.Ge-Accordion-item--open) .Ge-Accordion-item-content').attr('aria-hidden','true');
        $el.find('.Ge-Accordion-item:not(.Ge-Accordion-item--open) .Ge-Accordion-item-header').attr('aria-expanded','false');
    };

    const registerEvents = function() {
        $el.find('[data-js-accordion-toggler]').click(toggleAccordion);
    };

    const toggleAccordion = function(ev) {
        ev.stopImmediatePropagation();
        if (!acceptingClicks) {
            return;
        }
        const $clicker = $(this);
        const $accordionItem = $clicker.closest('[data-js-accordion-item]');
        const $accordionContent = $accordionItem.find('.Ge-Accordion-item-content');
        const $accordionHeader = $accordionItem.find('.Ge-Accordion-item-header');
        $accordionItem.toggleClass('Ge-Accordion-item--open').toggleClass('Ge-Accordion-item--closed');
        // aria
        if ($accordionItem.hasClass('Ge-Accordion-item--open')) {
            $accordionContent.attr('aria-hidden','false');
            $accordionHeader.attr('aria-expanded', 'true');
            // hide all aria and hidden fields
            a11yHelper.show($accordionContent);
        } else {
            $accordionContent.attr('aria-hidden','true');
            $accordionHeader.attr('aria-expanded', 'false');
            // enable all aria and hidden fields
            a11yHelper.hide($accordionContent);
        }
        // linked accordion behavior start
        $accordionItem.data('accordion-changing','1');
        linkedAccordion($accordionItem);
        $accordionItem.removeData('accordion-changing');
        // linked accordion behavior end
        acceptingClicks = false;
        setTimeout(function() {
            acceptingClicks = true;
            // inform other scripts that this accordion item has been toggled.
            app.trigger('accordionToggle',[$accordionItem]);
            // inform flickity to resize
            app.trigger('resizeFlickity');
        },300);
    };

    const linkedAccordion = function() {
        if ($el.attr('data-js-accordion') !== 'linked') {
            return;
        }
        let $items = $el.find('[data-js-accordion-item]');
        let itemsFiltered = [];
        $.each($items,function(index,el) {
            if (!$(el).data('accordion-changing')) {
                itemsFiltered.push(el);
            }
        });
        $(itemsFiltered).removeClass('Ge-Accordion-item--open');
    };

    return {
        init: init()
    };
};

accordionContent.selector = selector;

export default accordionContent;
